import { render, staticRenderFns } from "./RequestDeletion.vue?vue&type=template&id=29619c05"
import script from "./RequestDeletion.vue?vue&type=script&lang=js"
export * from "./RequestDeletion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports